<template>
    <div class="SideMenu-main" v-show="visible" @click="onComplete('close')">
        <transition name="sideLeft">
            <div class="SideMenu-container" v-show="visible" @click.stop>
                <div class="SideMenu-item" :class="currentPage == 'Home' && 'active'" @click="selectMenu('Home')">首页</div>
                <div class="SideMenu-item" :class="currentPage == 'DiamondSearch' && 'active'" @click="selectMenu('DiamondSearch')">GIA裸钻</div>
                <div class="SideMenu-item" :class="currentPage == 'MyCar' && 'active'" @click="selectMenu('MyCar')">我的购物车</div>
                <div class="SideMenu-item" :class="currentPage == 'MyOrder' && 'active'" @click="selectMenu('MyOrder')">我的订单</div>
                <div class="SideMenu-item" :class="currentPage == 'Calculator' && 'active'" @click="selectMenu('Calculator')">计算器</div>
                <div class="SideMenu-item" :class="currentPage == 'FeedBack' && 'active'" @click="selectMenu('FeedBack')">问题反馈</div>
                <div class="SideMenu-item" :class="currentPage == 'ChangePass' && 'active'" @click="selectMenu('ChangePass')">修改密码</div>
                <div class="SideMenu-item" @click="loginOut">注销登录</div>
            </div>
        </transition>
    </div>
</template>

<script>
    import Core from '@/until/core'
    export default {
        name: 'SideMenu',
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {}
        },
        computed: {
            currentPage () {
                return this.$store.state.currentPage
            }
        },
        methods: {
            onComplete (state) {
                this.$emit('onComplete', state)
            },
            loginOut () {
                Core.onRemoveToken()
                Core.goNext('StaffLogin', this.$route.params, true)
            },
            selectMenu (name) {
                this.$emit('onComplete', 'close')
                Core.goNext(name, this.$route.params)
            }
        },
        mounted () {}
    }
</script>
<style scoped>
    .SideMenu-main{ position: absolute; left: 0; bottom: 0; top: 0; right: 0; background-color: rgba(0,0,0,0.5); z-index: 12; padding-right: 1.7rem; }
    .SideMenu-container{ width: 100%; height: 100%; background-color: #fff; padding: 1rem 0.26rem 0; }
    .SideMenu-item{ width: 100%; height: 0.7rem; line-height: 0.68rem; border-bottom: 1px solid #ebebeb; font-size: 0.28rem; }
    .SideMenu-item.active{ color: #ff410f; }
    .SideMenu-item.out{ color: #EB3C38; }
</style>



// WEBPACK FOOTER //
// src/public/SideMenu.vue